import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(theme => ({
  alertContainer: {
    marginBottom: theme.spacing(1.5),
    '& > div': {
      margin: 'initial', // Have icon & text left aligned as per design
    },
  },
  signerField: {
    paddingTop: theme.spacing(3),
  },
  // Sits directly under the template picker as its helper line, so it stays
  // grouped with the field it refers to rather than with the assignment fields
  // below it.
  templateEditorLink: {
    display: 'inline-block',
    marginTop: theme.spacing(1),
    ...theme.typography.h5,
    color: theme.palette.primary.main,
  },
  // The counterpart to `alertContainer`, which sits ABOVE the fields it warns
  // about and so pushes its margin down.
  warningAlert: {
    marginTop: theme.spacing(3),
    '& > div': {
      margin: 'initial',
    },
  },
  warning: {
    marginTop: theme.spacing(3),
  },
  button: {
    width: 'auto',
  },
}));
